import React from 'react';
import DatePicker from 'react-datepicker'
import qs from 'qs';
import { format as formatDate, addWeeks, startOfWeek } from 'date-fns';
import classnames from 'classnames';
import { useLocation, useHistory } from 'react-router';
import { Button } from 'reactstrap';

import { fullPathWithParams, } from '../util';

export default function QueryWeekSelector(props) {
  const { paramName, label, defaultValue, disabled = false, invalid = false, ...extraProps } = props;
  const location = useLocation();
  const history = useHistory();
  const { [paramName]: value = defaultValue && formatDate(startOfWeek(defaultValue, { weekStartsOn: 1 }), 'yyyy-MM-dd') } = qs.parse(decodeURI(location.search.slice(1)));
  const selectedDate = value ? new Date(value) : null;
  
  const onSelect = (date) => {
    const weekStart = startOfWeek(date, { weekStartsOn: 1 });
    const path = fullPathWithParams({ [paramName]: date ? formatDate(weekStart, 'yyyy-MM-dd') : undefined }, location);
    history.replace(encodeURI(path));
  };

  const navigateWeek = (direction) => {
    const currentWeek = selectedDate || defaultValue;
    const newWeek = addWeeks(currentWeek, direction);
    onSelect(newWeek);
  };

  return (
    <div {...extraProps}>
      <div className="text-muted small">{label}</div>
      <div className="d-flex align-items-center gap-1">
        <Button 
          size="sm" 
          outline 
          onClick={() => navigateWeek(-1)}
          disabled={disabled}
        >
          <i className="fas fa-chevron-left"></i>
        </Button>
        <DatePicker
          dateFormat="yyyy/MM/dd"
          selected={selectedDate}
          onChange={onSelect}
          className={classnames('form-control', ({ 'is-invalid': invalid }))}
          disabled={disabled}
          locale="ja"
          showWeekPicker
          weekLabel="週"
          calendarStartDay={1}
        />
        <Button 
          size="sm" 
          outline 
          onClick={() => navigateWeek(1)}
          disabled={disabled}
        >
          <i className="fas fa-chevron-right"></i>
        </Button>
      </div>
    </div>
  );
};
